import React from "react"
import { DEFAULT_SIZE } from "utils/icons"

const ChevronExpandIcon = ({ 
    size = DEFAULT_SIZE, 
    color = "currenColor" 
}) => {
	return (
		<svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={size} 
            width={size} 
            viewBox="0 0 32 32" 
            aria-hidden="true"
        >
           <path fill={color} d="M23.778 18.257a1 1 0 0 1 0 1.414l-7.071 7.072a1 1 0 0 1-1.414 0l-7.071-7.072a1 1 0 1 1 1.414-1.414L16 24.622l6.364-6.365a1 1 0 0 1 1.414 0zM9.636 13.743 16 7.378l6.364 6.365a1 1 0 0 0 1.414-1.414l-7.071-7.072a1 1 0 0 0-1.414 0l-7.071 7.072a1 1 0 1 0 1.414 1.414z"/>
        </svg>
	)
}

export default ChevronExpandIcon